import { invokeAction } from '../../lib/globalActions'

export default {
  show: message => {
    invokeAction('FlashMessages', 'addFlashMessage', message)
  }
}
